import { render, staticRenderFns } from "./DetailPurchaseOrder.vue?vue&type=template&id=58ee1c7e&"
import script from "./DetailPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./DetailPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports